export default __webpack_public_path__ + "static/media/play-video.25544ad4.png";